<template>
  <div>
    <div class="sticky-filter-header" @click="isOpen = true" v-if="!isOpen && !hideStickyHeader">
      <div class="filter-title">FILTERS</div>
      <button class="toggle-filter-button"><i class="fa fa-chevron-up"></i></button>
    </div>
    <div class="sidebar-wrapper" @click="isOpen = false" v-if="isOpen"></div>
    <transition
      name="slide"
      @before-enter="beforeEnter"
      @after-leave="afterLeave">
    >
      <div id="sidebar-mobile" v-if="isOpen">
        <div class="filter-header">
          <div class="filter-title">FILTERS</div>
          <button class="close-filter-button" @click="isOpen = false"><i class="fa fa-chevron-down"></i></button>
        </div>
          <Filters></Filters>
          <b-button class="custom-button" type="is-primary" @click="isOpen = false"
          >Apply filters</b-button
        >
      </div>
    </transition>
  </div>
</template>

<script>
import Filters from "@/components/Filters.vue";

export default {
  name: "sidebar-mobile",
  data: function () {
    return {
      isOpen: false,
      hideStickyHeader: false,
    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    beforeEnter() {
    this.hideStickyHeader = true;
    },
    afterLeave() {
      this.hideStickyHeader = false;
    },
  },
  components: {
    Filters,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";
@keyframes slide-in-bottom {
  from {
    transform: translateY(100%); /* Start from below the current position */
  }
  to {
    transform: translateY(0); /* End at the current position */
  }
}

.sidebar-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.1;
  z-index: 103;
}

#sidebar-mobile {
  z-index: 104;
  background: $light;
  position: fixed;
  height: 80%;
  bottom: 0;
  top: 20%;
  left: 0;
  right: 0;
  box-shadow: 8px 10px 8px -8px #888;
  padding: 1.5em;
  padding-top: 0;
  border-top: 4px solid #BE7D2D;
  border-radius: 12px;
  overflow-y: auto;
  // Hide scrollbar
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  &::-webkit-scrollbar {
    display: none;
  }
  .filter-header {
    position: sticky;  // Makes filter header sticky
    top: 0;
    z-index: 10;
    background: $light;
    padding-top: 1.5em;
  }

  Filters, Filters * {
    overflow-y: auto;
  }
}

.toggle-filters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2em;
  color: darken($primary-dark, 30%);
  i {
    margin-left: 0.5em;
  }
}

.slide-enter-active {
  animation: slide-in-bottom 0.2s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.slide-leave-active {
  animation: slide-in-bottom 0.2s cubic-bezier(1, 0.5, 0.8, 1) both reverse;
}
.filter-header {
  display: flex;           // make it a flex container
  justify-content: space-between;  // space items out
  align-items: center;     // align items vertically in the center
  .close-filter-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #E6E5E1;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    transition: background-color 0.3s ease;

    i {
      color: #30384A;
    }
  }

  .close-filter-button:hover {
    background-color: #E6E5E1;
  }
}
.sticky-filter-header {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: $light;
  z-index: 105;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 8px 10px 8px -8px #888;
  padding: 1.5em;
  border-top: 4px solid #BE7D2D;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  .toggle-filter-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #E6E5E1;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease;

    i {
      color: #30384A;
      transition: transform 0.3s ease;
    }
  }

  .toggle-filter-button:hover {
    background-color: darken(#E6E5E1, 10%);  // Darken the button on hover for better feedback
  }
}
.filter-title {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    letter-spacing: 0.2em;
    text-transform: uppercase;

    /* color/sys/light/text/lvl-1 */

    color: #30384a;
  }
.custom-button {
  width: 100%;
  margin-bottom: 16px;
  border-radius: 104px !important;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em !important;

  /* color/sys/light/text/contrast */

  color: #ffffff;
}
</style>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.b-slider .b-slider-tick-label {
  font-size: 0.75rem;
  position: absolute;
  top: 0.75em !important;
}

.b-slider .b-slider-thumb-wrapper .b-slider-thumb {
  border-radius: 100% !important;
}

.my-label .label {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #02214d;
}

.select.is-fullwidth select {
  background: $cararra !important;
}

.b-checkbox.checkbox input[type="checkbox"] + .check {
  border-radius: 4px !important;
}
</style>